
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'refresh': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.99 16',
    data: '<path pid="0" d="M13.64 2.35A7.958 7.958 0 0 0 7.99 0 7.989 7.989 0 0 0 0 8a7.989 7.989 0 0 0 7.99 8 7.983 7.983 0 0 0 7.73-6h-2.08a5.991 5.991 0 0 1-5.65 4 6 6 0 0 1-6-6 6 6 0 0 1 6-6 5.915 5.915 0 0 1 4.22 1.78L8.99 7h7V0l-2.35 2.35z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
